import './App.css';
import Home from './components/home/Home';
import { Route, Routes } from 'react-router-dom';
import AllProject from './components/home/AllProject';
import { useEffect, useState } from 'react';
import CircleLoader
  from "react-spinners/CircleLoader";
import ErrorPages from './components/home/ErrorPages';
import Experience from './components/professional/Experience';



function App() {
  let [loading, setLoading] = useState(false);
  useEffect(() => {
    setLoading(true)
    setTimeout(() => {
      setLoading(false)

    }, 4000);
  },[])


  return (
    <div className=" bg-[#020617]" >

{
  loading?
<div className="h-screen grid justify-center items-center">
            <CircleLoader

              color={"#2874f0"}
              loading={loading}
              size={150}
              className='h-screen'

            />
            
</div>
          :
         <>
           
            <Routes>
              <Route path='/' element={<Home />}></Route>
              <Route path='/allproject' element={<AllProject />}></Route>
              <Route path='/experience' element={<Experience />}></Route>
              <Route path='/*' element={<ErrorPages />}></Route>
            </Routes>
              
         </>

}

    </div>
  );
}

export default App;
